import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import styled from 'styled-components';
import styles from './SubmenuNav.style';
import Anchor from '../../../atoms/Anchor';
import List from '../../List';
import ListItem from '../../List/ListItem';
var SubmenuNav = /*#__PURE__*/function (_Component) {
  _inherits(SubmenuNav, _Component);
  var _super = _createSuper(SubmenuNav);
  function SubmenuNav() {
    _classCallCheck(this, SubmenuNav);
    return _super.apply(this, arguments);
  }
  _createClass(SubmenuNav, [{
    key: "render",
    value:
    // Set default props and state

    function render() {
      var menuClassName = this.props.isMenuOpen ? 'open ' + this.props.className : this.props.className;
      return __jsx("div", {
        className: menuClassName
      }, this.props.menuGroup.map(function (g, index) {
        var groupItemCollection = g.groupItemCollection,
          sys = g.sys;
        var groupItem = groupItemCollection && groupItemCollection.items;
        var id = sys && sys.id;
        return __jsx("div", {
          key: id,
          className: "sub-menu-list"
        }, groupItem && groupItem.map(function (item, index) {
          return __jsx("div", {
            key: item.sys && item.sys.id
          }, item.itemName && __jsx(List, null, __jsx(ListItem, {
            key: item.sys && item.sys.id,
            className: "sub-menu-heading heading_four"
          }, item.itemName)), !item.itemName && __jsx(List, {
            className: "sub-menu-nav"
          }, __jsx(ListItem, {
            key: item.sys && item.sys.id,
            className: "sub-menu-item"
          }, __jsx(Anchor, {
            title: item.label,
            "aria-label": item.ariaLabel,
            className: "sub-menu-link",
            to: item.url,
            ctaBehavior: item.behavior,
            hyperlinkType: item.hyperlinkType,
            styleType: "secondary-link",
            "data-analytics-type": "sub-menu"
          }, item.label))));
        }));
      }));
    }
  }]);
  return SubmenuNav;
}(Component);
_defineProperty(SubmenuNav, "defaultProps", {
  className: '',
  isMenuOpen: false
});
export default styled(SubmenuNav).withConfig({
  componentId: "sc-1d8mz6m-0"
})(["", ";"], styles);